import React from "react";

import { Tag } from "@chakra-ui/react";

export default function UserRoleTags(props) {
  const { role } = props;

  const roleColor = {
    admin: "#0D5CD2",
    user: "#F48927",
    subscriber: "#F48927",
    none: "#F04438",
  };

  return (
    <Tag
      size="sm"
      key="sm"
      variant="solid"
      background={`${roleColor[role.toLowerCase()]}3A`}
      textColor={`${roleColor[role.toLowerCase()]}`}
      borderRadius={"1.375rem"}
    >
      {role}
    </Tag>
  );
}
